var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"chart"}},[_c('h2',[_vm._v("A live (unofficial) dashboard for covid-19 India")]),_vm._v(" "),_c('div',{attrs:{"id":"chart-plot"}},[_c('highcharts',{attrs:{"options":_vm.chartOptionsCumm}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('highcharts',{attrs:{"options":_vm.chartOptionsDaily}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-284379b6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HelloWorld.vue
// module id = null
// module chunks = 